
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Loader from "../Components/loader/Loader";
import Layout from "../Layout";
import Login from "../Components/login/Login";
import NotFound from "../Components/notfound/NotFound";
import Mission from "../Pages/manaage_mission/Mission";
import MissionView from "../Pages/manaage_mission/MissionView";
import AddEditMission from "../Pages/manaage_mission/AddEditMission";
import PlatformCMS from "../Pages/cms/CMS";
import MoreInfoSupport from "../Pages/moreInfoSupport/MoreInfoSupport";

const Dashboard = lazy(() => import("../Pages/dashboard/Dashboard"));
// const Setting = lazy(() => import("../Pages/setting/Setting"));
const Report = lazy(() => import("../Pages/reports_analytics/Report"));
const Marketing = lazy(() => import("../Pages/marketing/Marketing"));
const MarketingView = lazy(() => import("../Pages/marketing/MarketingView"));
const Payment = lazy(() => import("../Pages/payment/Payment"));
const Support = lazy(() => import("../Pages/support_operation/Support"));
const UserManagement = lazy(() => import("../Pages/userManagement/UserManagement"));
const Forgot = lazy(() => import("../Components/login/Forgot"));
const ResetPassword = lazy(() => import("../Components/login/ResetPassword"));
const Verifyotp = lazy(() => import("../Components/login/Verifyopt"));
const Register = lazy(() => import("../Components/login/Register"));
const Teams = lazy(() => import("../Pages/teams/Teams"));
const Community=lazy(()=>import("../Pages/community/community"));




const AppRoutes = () => {
  const isLoggedIn = true;
  const protectedRoutes = [
    { path: "/dashboard", element: <Dashboard />, layout: true },
    // { path: "/setting", element: <Setting />, layout: true },
    { path: "/report", element: <Report />, layout: true },
    { path: "/marketing", element: <Marketing />, layout: true },
    { path: "/marketing-view/:id", element: <MarketingView />, layout: true },
    { path: "/payment", element: <Payment />, layout: true },
    { path: "/support", element: <Support />, layout: true },
    { path: "/users", element: <UserManagement />, layout: true },
    { path: "/forgot", element: <Forgot />, layout: false },
    { path: "/resetpassword", element: <ResetPassword />, layout: false },
    { path: "/verifyotp", element: <Verifyotp />, layout: false },
    { path: "/register", element: <Register />, layout: false },
    { path: "/missions", element: <Mission />, layout: true },
    { path: "/mission-view/:id", element: <MissionView />, layout: true },
    { path: "/add-mission", element: <AddEditMission />, layout: true },
    { path: "/cms", element: <PlatformCMS />, layout: true },
    { path: "/more-info", element: <MoreInfoSupport />, layout: true },
    { path: "/edit-mission/:id", element: <AddEditMission />, layout: true },
    { path: "/teams", element: <Teams />, layout: true },
    { path: "/community", element: <Community />, layout: true }

  ];

  return (
    <BrowserRouter>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<Login />} />
          {protectedRoutes.map(({ path, element, layout }) => (
            <Route
              key={path}
              path={path}
              element={
                isLoggedIn
                  ? (layout ? <Layout>{element}</Layout> : element)
                  : <Navigate to="/" replace />
              }
            />
          ))}

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default AppRoutes;